import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-100 font-sans text-gray-800">
      {/* Header Section */}
      <header className="bg-blue-600 text-white py-6">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold">Terms and Conditions</h1>
          <p className="mt-1 text-lg">
            Use of PreciseDraft – a brand of Documore LLC, USA (Massachusetts)
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-10">
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">1. Introduction</h2>
          <p>
            Welcome to PreciseDraft, a service provided by Documore LLC based in Massachusetts, USA.
            These Terms and Conditions ("Terms") govern your access to and use of our website and services.
            By using our services, you agree to these Terms.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">2. Acceptance of Terms</h2>
          <p>
            By accessing or using PreciseDraft, you acknowledge that you have read, understood,
            and agree to be bound by these Terms. If you do not agree, please refrain from using our services.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">3. Eligibility and Scope</h2>
          <p>
            Our services are intended for users in the United States, Europe, and Asia. In addition to U.S. laws,
            users from Europe and Asia must also comply with regional regulations such as the GDPR, CCPA, and other applicable privacy laws.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">4. Use of Our Services</h2>
          <p>
            You agree to use our services only for lawful purposes and in a manner that does not infringe
            on the rights of, restrict or inhibit anyone else's use and enjoyment of PreciseDraft.
            Unauthorized use may result in legal action.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">5. Intellectual Property</h2>
          <p>
            All content provided on PreciseDraft, including text, graphics, logos, images, and software,
            is the property of Documore LLC or its licensors and is protected by intellectual property laws.
            Unauthorized reproduction or modification of any content is prohibited.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">6. Limitation of Liability</h2>
          <p>
            Under no circumstances shall Documore LLC be liable for any indirect, incidental, special,
            or consequential damages arising from the use or inability to use our services.
            Your use of PreciseDraft is at your sole risk.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">7. Governing Law and Jurisdiction</h2>
          <p>
            These Terms shall be governed by and construed under the laws of the Commonwealth of Massachusetts, USA,
            for U.S. users. For users in Europe and Asia, local laws and regulations, including data protection statutes such as the GDPR,
            shall also apply. Any disputes shall be resolved in the appropriate jurisdiction.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">8. Changes to the Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. Any changes will be posted on this page,
            and your continued use of PreciseDraft after such modifications constitutes your acceptance of the updated Terms.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-4">9. Contact Us</h2>
          <p>
            If you have any questions regarding these Terms and Conditions, please contact us at <a href="mailto:support@precisedraft.ai" className="text-blue-600 underline">support@precisedraft.ai</a>.
          </p>
        </section>
      </main>

      {/* Footer Section */}
      <footer className="bg-gray-800 text-white py-4">
        <div className="container mx-auto px-4 text-center">
          <p>&copy; {new Date().getFullYear()} Documore LLC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
